import React, { useState } from "react";
import { Button, Card, Flex, Form, Select, Table, Upload, message } from "antd";
import { FileExcelOutlined, InboxOutlined } from "@ant-design/icons";
import axios from "axios";

import Apiurl from "../ConstURL";
import Header from "../components/Header";

export default function Addtask() {
    const [form] = Form.useForm();

    const [FindedList, setFindedList] = useState([]);
    const [Loading, setLoading] = useState(false);

    // сохраняем последние списки (нужны для скачивания /function2/getfile)
    const [LastSkuList, setLastSkuList] = useState([]);
    const [LastAsinList, setLastAsinList] = useState([]);

    const columns = [
        { title: "Id", dataIndex: "id", key: "id" },
        { title: "Zoro_sku", dataIndex: "Zoro_sku", key: "Zoro_sku" },
        { title: "seller-sku", dataIndex: "seller-sku", key: "seller-sku" },
        { title: "asin1", dataIndex: "asin1", key: "asin1" },
        { title: "item-name", dataIndex: "item-name", key: "item-name" },
        { title: "price", dataIndex: "price", key: "price" },
        { title: "quantity", dataIndex: "quantity", key: "quantity" },
        { title: "status", dataIndex: "status", key: "status" },
        {
            title: "minimum-seller-allowed-price",
            dataIndex: "minimum-seller-allowed-price",
            key: "minimum-seller-allowed-price",
        },
        {
            title: "maximum-seller-allowed-price",
            dataIndex: "maximum-seller-allowed-price",
            key: "maximum-seller-allowed-price",
        },
        { title: "Filename", dataIndex: "Filename", key: "Filename" },
    ];

    const unique = (arr) => Array.from(new Set(arr));

    const parseTokens = (text) => {
        return unique(
            (text || "")
                .split(/[\s,;]+/g) // пробел, enter, tab, запятая, ;
                .map((v) => v.trim())
                .filter(Boolean)
        );
    };

    const normalizeSelectValues = (values) => {
        if (!values) return [];
        if (Array.isArray(values)) return parseTokens(values.join(" "));
        return parseTokens(String(values));
    };

    const appendToFormField = (fieldName, items) => {
        const current = form.getFieldValue(fieldName) || [];
        const merged = unique([...(Array.isArray(current) ? current : []), ...items]);
        form.setFieldsValue({ [fieldName]: merged });
    };

    const handleTxtUpload = (fieldName) => async (file) => {
        try {
            const text = await file.text();
            const parsed = parseTokens(text);
            if (parsed.length === 0) {
                message.warning("В файле не найдено значений");
                return Upload.LIST_IGNORE;
            }
            appendToFormField(fieldName, parsed);
            message.success(`Добавлено ${parsed.length} значений из ${file.name}`);
        } catch (e) {
            console.error(e);
            message.error("Не удалось прочитать TXT файл");
        }
        return Upload.LIST_IGNORE; // не грузим файл на сервер
    };

    const Sendrequest = async (values) => {
        const skuList = normalizeSelectValues(values.skuList);
        const asinList = normalizeSelectValues(values.asinList);

        // (опционально) поддержка старых одиночных полей, если где-то остались
        if (values.sku) skuList.push(...parseTokens(values.sku));
        if (values.asin) asinList.push(...parseTokens(values.asin));

        const finalSkuList = unique(skuList);
        const finalAsinList = unique(asinList);

        if (finalSkuList.length === 0 && finalAsinList.length === 0) {
            message.warning("Добавьте хотя бы один SKU или ASIN");
            return;
        }

        setLoading(true);
        try {
            const token = localStorage.getItem("token") || "";

            // Новый формат: массивы в JSON body
            const res = await axios.post(
                `${Apiurl}/function2?token=${encodeURIComponent(token)}`,
                {
                    search: finalSkuList,
                    asins: finalAsinList,
                }
            );

            if (res && res.data && res.data.Status) {
                const data = Array.isArray(res.data.Data) ? res.data.Data : [];
                const withIds = data.map((item, index) => ({
                    ...item,
                    id: index + 1,
                }));

                setFindedList(withIds);

                // сохраняем параметры последнего успешного поиска (для скачивания Excel)
                setLastSkuList(finalSkuList);
                setLastAsinList(finalAsinList);
            } else {
                message.error("Ошибка");
            }
        } catch (err) {
            console.error(err);
            message.error("Ошибка запроса");
        } finally {
            setLoading(false);
        }
    };

    // Скачивание Excel через POST + blob (поддерживает массивы sku/asin)
    const downloadExcel = async () => {
        const token = localStorage.getItem("token") || "";

        if (LastSkuList.length === 0 && LastAsinList.length === 0) {
            message.warning("Нет данных для скачивания");
            return;
        }

        try {
            const res = await axios.post(
                `${Apiurl}/function2/getfile?token=${encodeURIComponent(token)}`,
                {
                    search: LastSkuList,
                    asins: LastAsinList,
                },
                { responseType: "blob" }
            );

            // filename из Content-Disposition (если доступен)
            let filename = "TASK2.xlsx";
            const cd = res.headers?.["content-disposition"];
            if (cd) {
                const m = cd.match(/filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i);
                filename = decodeURIComponent((m && (m[1] || m[2])) || filename);
            }

            const blob = new Blob([res.data], {
                type:
                    res.headers?.["content-type"] ||
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error(err);
            message.error("Не удалось скачать файл");
        }
    };

    return (
        <div>
            <Header />
            <Flex justify="center" style={{ paddingTop: "25px" }}>
                <Card style={{ width: "95vw" }} title="Поиск дублей">
                    <Form
                        layout="vertical"
                        name="search-form"
                        form={form}
                        initialValues={{ skuList: [], asinList: [] }}
                        onFinish={Sendrequest}
                        autoComplete="off"
                    >
                        <Flex gap={1} vertical={true}>
                            <Form.Item
                                label="SKU"
                                name="skuList"
                                style={{ minWidth: 380, flex: 1 }}
                                extra="Вставляйте список через пробел, Enter, tab, запятую или ;"
                            >
                                <Select
                                    mode="tags"
                                    placeholder="Например: G12345 G67890 (или с новой строки)"
                                    tokenSeparators={[" ", "\n", "\t", ",", ";"]}
                                    open={false}
                                />
                            </Form.Item>

                            <Upload
                                accept=".txt,text/plain"
                                showUploadList={false}
                                beforeUpload={handleTxtUpload("skuList")}
                            >
                                <Button icon={<InboxOutlined />}>Загрузить SKU из TXT</Button>
                            </Upload>
                        </Flex>

                        <Flex gap={1} vertical={true} style={{ marginTop: 20 }}>
                            <Form.Item
                                label="ASIN"
                                name="asinList"
                                style={{ minWidth: 380, flex: 1 }}
                                extra="Также поддерживается вставка через пробел/Enter"
                            >
                                <Select
                                    mode="tags"
                                    placeholder="Например: B0XXXXXXX B0YYYYYYY"
                                    tokenSeparators={[" ", "\n", "\t", ",", ";"]}
                                    open={false}
                                />
                            </Form.Item>

                            <Upload
                                accept=".txt,text/plain"
                                showUploadList={false}
                                beforeUpload={handleTxtUpload("asinList")}
                            >
                                <Button icon={<InboxOutlined />}>Загрузить ASIN из TXT</Button>
                            </Upload>
                        </Flex>

                        <Form.Item>
                            <Button
                                style={{ marginTop: 25 }}
                                type="primary"
                                htmlType="submit"
                                size="large"
                                loading={Loading}
                            >
                                Поиск
                            </Button>
                        </Form.Item>
                    </Form>

                    {FindedList.length > 0 &&
                    (LastSkuList.length > 0 || LastAsinList.length > 0) ? (
                        <Button
                            type="primary"
                            size="large"
                            icon={<FileExcelOutlined />}
                            style={{ marginTop: 8 }}
                            onClick={downloadExcel}
                        >
                            Скачать
                        </Button>
                    ) : null}

                    <Table
                        style={{ paddingTop: "25px" }}
                        loading={Loading}
                        columns={columns}
                        dataSource={FindedList}
                        rowKey={(record) => record.id}
                        pagination={{
                            showSizeChanger: true,
                            showTotal: () => `Найдено ${FindedList.length}`,
                            position: ["bottomCenter"],
                            pageSizeOptions: [10, 20, 30, 40, 50, 100],
                        }}
                    />
                </Card>
            </Flex>
        </div>
    );
}
